import { useLayoutEffect, useRef, useState } from 'react'

import { FONT_SIZE, TEXT_BOX_RADIUS, GAP, COLOR_BLACK, COLOR_WHITE } from './constants'

interface ISvgTextProps {
  x: number
  y: number
  text: string | number
  placement?: 'center' | 'top' | 'bottom' | 'left' | 'right' | ['top' | 'bottom', 'left' | 'right']
  dark?: boolean
  transform?: string
  color?: string
  background?: string
  border?: string
  gap?: number
  rx?: number
  ry?: number
}

const SvgText: React.FC<ISvgTextProps> = ({
  x,
  y,
  text,
  placement: p = 'center',
  color = COLOR_BLACK,
  background = COLOR_WHITE,
  border = COLOR_WHITE,
  dark = false,
  transform,
  gap = GAP,
  rx = TEXT_BOX_RADIUS,
  ry = TEXT_BOX_RADIUS,
}) => {
  const textRef = useRef<SVGTextElement>(null)
  const [textWidth, setTextWidth] = useState(0)
  const [textHeight, setTextHeight] = useState(0)
  const rectWidth = textWidth + 2 * gap
  const rectHeight = textHeight + gap

  const adjustedY = p.includes('top')
    ? y - rectHeight - gap
    : p.includes('bottom')
      ? y + gap
      : y - rectHeight / 2

  const adjustedX = p.includes('left')
    ? x - rectWidth - gap
    : p.includes('right')
      ? x + gap
      : x - rectWidth / 2

  useLayoutEffect(() => {
    if (textRef.current) {
      const bbox = textRef.current.getBBox()
      setTextWidth(bbox.width)
      setTextHeight(bbox.height)
    }
  }, [text])

  return (
    <g>
      <rect
        fill={dark ? background : background}
        height={rectHeight}
        rx={rx}
        ry={ry}
        stroke={border}
        transform={transform}
        width={rectWidth}
        x={adjustedX}
        y={adjustedY}
      />
      <text
        dominantBaseline='central'
        fill={color}
        fontSize={FONT_SIZE}
        ref={textRef}
        textAnchor='middle'
        transform={transform}
        x={adjustedX + rectWidth / 2}
        y={adjustedY + rectHeight / 2}
      >
        {typeof text === 'number' ? Math.round(text) : text}
      </text>
    </g>
  )
}

export default SvgText
